import DeleteAudienceSegment from "./DeleteAudienceSegment";

export default DeleteAudienceSegment